import {emailValidator, maxLengthValidator, minLengthValidator, notBlankValidator, patternValidator, requiredValidator, urlValidator} from '../../shared/validators';
import type {Validator} from 'svelte-forms';
import type {TextValueEditorOptions, TextValueEditorValidations, TTextValueEditorType} from './types';
import {isDefined} from '../../../../utils/custom-utils';
import type {Formatter, Parser} from '../../forms/types';
import {isString} from 'shared/utils/string-utils';

export function validatorFactory(validations: TextValueEditorValidations, textEditorType: TTextValueEditorType): Validator[] {
    const validators: Validator[] = [];

    if (isDefined(validations.required) && validations.required) {
        validators.push(requiredValidator());
    }

    if(isDefined(validations.maxlength)) {
        validators.push(maxLengthValidator(validations.maxlength));
    }

    if (isDefined(validations.minlength)) {
        validators.push(minLengthValidator(validations.minlength));
    }

    if (isDefined(validations.notBlank) && validations.notBlank) {
        validators.push(notBlankValidator());
    }

    if (isDefined(validations.pattern)) {
        validators.push(patternValidator(new RegExp(validations.pattern)));
    }

    if (textEditorType === 'email') {
        validators.push(emailValidator());
    }

    if (textEditorType === 'url') {
        validators.push(urlValidator());
    }

    return validators;
}

export function addPrefixAndSuffix(options: TextValueEditorOptions): Parser {
    const hasContent = (value: string) => value !== null && value !== undefined && value.trim() !== '';

    return (modelValue: string): string => {
        if (options.includePrefixAndSuffixToModel && hasContent(modelValue)) {
            if (options.prefix) {
                modelValue = options.prefix + modelValue;
            }
            if (options.suffix) {
                modelValue = modelValue + options.suffix;
            }
        }
        return modelValue;
    };
}

export function trimPrefixAndSuffix(options: TextValueEditorOptions): Formatter {
    return (modelValue: string): string => {
        if (options.includePrefixAndSuffixToModel && isString(modelValue)) {
            return modelValue
                .replace(new RegExp(`^${options.prefix}`), '')
                .replace(new RegExp(`${options.suffix}$`), '');
        }

        return modelValue;
    }
}